
import React, { Fragment } from "react";
import _ from "lodash";
import {
  Button,
  IconButton,
  Radio,
  Checkbox,
  RadioGroup,
  FormControlLabel
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const DashContainer = styled.div`
width: 100%;
margin-top: 40px;
margin-bottom: 25px;
`;

const PermsSelectContainer = styled.div`
    &&{
        width:25%;
        height: 100%;
        display: inline-block;
        vertical-align: top;
    }
`;

const RadioContainer = styled.div`
    &&{
        color:black;
        height: 100%;
        display:inline-block;
        margin-left: 40px;
    }
`;

const StyledRadio = styled(Radio)`
    &&{
        color: black;
        width:97%;
    }
`;

const MetricsContainer = styled.div`
    &&{
        height: 100%;
        width: 35%;
        padding-left: 40px;
        display: inline-block;
        color:black;
        border-left: 1px solid gray;
    }
`;

const StyledCheckbox = styled(Checkbox)`
    &&{
        color:black;
    }
`;

const SummaryBox = styled.div`
    &&{
        height:100%;
        width: 35%;
        display: inline-block;
        vertical-align: top;
    }
`;
const SummaryTitle = styled.div`
    &&{
        color:black;
        margin-bottom: 15px;
    }
`;

const SummaryBody = styled.p`
    &&{
        margin-bottom: 10px;
    }
`;
const SectionHeader = styled.p`
    font-size: 20px;
    color: #999999;
`;

const ClearButton = styled(Button)`
  && {
    margin-top: -3px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

/*
 * currentPerm = "view" "edit"
 * metricsPerm = "full" "restricted" "none"
 */
const PipelineDealPermissionDash = ({ onClickView, onClickEdit, onToggleMetrics, metricsPerm, currentPerm, setMetricsPerm, showHeader, onClear, isMinimized, onShow, projectionsEnabled, lenderReportingEnabled, toggleProjections, toggleLenderReporting, isSysAdmin }) => {
  const isView = currentPerm ? currentPerm.toLowerCase() === "view" : false;
  const isEdit = currentPerm ? currentPerm.toLowerCase() === "edit" : false;

  return (
    <DashContainer style={{ height: isMinimized ? "0px" : "215px", marginLeft: showHeader ? "0px" : "-35px" }}>
      {showHeader && <SectionHeader>
        PORTFOLIO
        <ClearButton onClick={isMinimized ? onShow : onClear}>{isMinimized ? "Add Permissions" : "Clear permissions"}</ClearButton>
      </SectionHeader>}
      {!isMinimized && <>
        <PermsSelectContainer>
          <RadioContainer>
            <p>View</p>
            <StyledRadio checked={isView} onClick={onClickView} />
          </RadioContainer>
          <RadioContainer>
            <p>Edit</p>
            <StyledRadio checked={isEdit} onClick={onClickEdit} />
          </RadioContainer>
        </PermsSelectContainer>
        <MetricsContainer>
          <div>Projections</div>
          <Checkbox
            style={{ color: projectionsEnabled ? "" : "black" }}
            checked={Boolean(projectionsEnabled)}
            onClick={toggleProjections}
          />
          <br />
          <div>Metrics</div>
          <StyledCheckbox checked={metricsPerm !== "none"} onClick={onToggleMetrics} style={{ marginRight: 30 }} />
          <FormControlLabel
            label={"Full"}
            labelPlacement="end"
            control={
              <Radio
                checked={metricsPerm === "full"}
                onClick={event => setMetricsPerm("full")}
                disabled={metricsPerm === "none"}
              />
            }
          />
          <FormControlLabel
            label={"Restricted"}
            labelPlacement="end"
            control={
              <Radio
                checked={metricsPerm === "restricted"}
                onClick={event => setMetricsPerm("restricted")}
                disabled={metricsPerm === "none"}
              />
            }
          />
          {isSysAdmin && (<span>
            <div>Lender Reporting</div>
            <Checkbox
              style={{ color: lenderReportingEnabled ? "" : "black" }}
              checked={Boolean(lenderReportingEnabled)}
              onClick={toggleLenderReporting}
            />
          </span>)}

        </MetricsContainer>
        <SummaryBox>
          <SummaryTitle>Summary</SummaryTitle>
          {isView && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view all deal details, active loans, and active hedges</SummaryBody>}
          {isEdit && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view and edit all deal details, active loans, and active hedges</SummaryBody>}
          {projectionsEnabled && (isView || isEdit) && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>{`Guest has access to view${isEdit ? " and edit" : ""} projections`}</SummaryBody>}
          {metricsPerm === "full" && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view all metrics</SummaryBody>}
          {metricsPerm === "restricted" && showHeader && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>
            Guest has access to view
            <NavLink exact to={"/admin/guestMetrics/"}>defined guest metrics</NavLink>
                                                         </SummaryBody>}
          {metricsPerm === "restricted" && !showHeader && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view  defined guest metrics</SummaryBody>}
          {!isView && !isEdit && metricsPerm === "none" && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has no permissions</SummaryBody>}
          {isSysAdmin && lenderReportingEnabled && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view, but not edit, all Lender Compliance Reports</SummaryBody>}
        </SummaryBox>
                       </>}
    </DashContainer>
  );
};

export default PipelineDealPermissionDash;
